export default {"src":"/_next/static/media/eye.141500e5.svg","height":24,"width":24};